import * as React from "react";
import { MUIDataTableMeta } from "mui-datatables";
import * as Dati from "src/Dati";
import { Trad } from "src/components";
import { _ChangeStatusButton, _GeneratedPolicyLink } from "../../components";

export const GetSpecialAcceptanceListColumns = (GetData: () => void) => [
    {
        name: "ID_Deroga",
        label: "ID",
        options: {
            filter: false,
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CDatiDeroga(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return (
                    <_GeneratedPolicyLink Id={val} Type={rowData.ID_TipoDerogaTipo}>
                        {val}
                    </_GeneratedPolicyLink>
                );
            }
        }
    },
    {
        name: "Tipo",
        label: Trad.Trad("Tipo"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "Stato",
        label: Trad.Trad("Stato"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "Note",
        label: Trad.Trad("Note deroga"),
        options: {
            filter: false,
            sort: false
        }
    },
    {
        name: "Creato",
        label: Trad.Trad("Data"),
        options: {
            filter: false,
            customBodyRender: (val: Date) => val.toLocaleDateString()
        }
    },
    {
        name: "ID_Deroga",
        label: Trad.Trad("Operazione"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CDatiDeroga(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return <_ChangeStatusButton RowData={rowData} GetData={GetData} />;
            }
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/SearchTableColumns/SpecialAcceptanceListColumns.tsx